import {InputTextArea, InputTextCustom, Switcher} from "../../components";
import {createRef, useContext, useState} from "react";
import {LoadingContext, PageContext, ToastContext, UserContext} from "../../contexts";
import {useLocation, useNavigate} from "react-router";
import {ArquivoApi, PublicacaoApi} from "../../apis";
import {FaNewspaper} from "react-icons/fa";

const inputRef = createRef();

export const PublicacaoEdit = () => {
  const {user} = useContext(UserContext);
  const {pageInfo, setPageInfo} = useContext(PageContext);
  const location = useLocation();
  const [carregado, setCarregado] = useState(false);
  const [publicacaoUuid, setPublicacaoUuid] = useState('');

  const [titulo, setTitulo] = useState('');
  const [errorTitulo, setErrorTitulo] = useState(false);
  const [helperTitulo, setHelperTitulo] = useState('');

  const [texto, setTexto] = useState('');
  const [errorTexto, setErrorTexto] = useState(false);
  const [helperTexto, setHelperTexto] = useState('');

  const [arquivos, setArquivos] = useState(null);

  const {setLoading} = useContext(LoadingContext);

  const [modalDelete, setModalDelete] = useState(false);
  const [itemDelete, setItemDelete] = useState('');

  const navigate = useNavigate();

  const toasts = useContext(ToastContext);
  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }

  const validarCampos = () => {
    setErrorTitulo(false);
    setErrorTexto(false);
    let erro = false;

    if (titulo.length === 0) {
      setHelperTitulo('O campo não pode estar vazio.');
      setErrorTitulo(true);
      erro = true
    }

    if (texto.length === 0) {
      setHelperTexto('O campo não pode estar vazio.');
      setErrorTexto(true);
      erro = true
    }

    return !erro;
  }

  const load = async () => {
    if (location.state.propUuid !== 0 || publicacaoUuid !== '') {
      setLoading(true);
      try {
        let respostaGetItem;
        if (publicacaoUuid !== '') {
          respostaGetItem = await PublicacaoApi.getItem(user.uuid, publicacaoUuid);
        } else {
          respostaGetItem = await PublicacaoApi.getItem(user.uuid, location.state.propUuid);
        }
        if (!respostaGetItem.error) {
          setPublicacaoUuid(respostaGetItem.data.publicacao.uuid);
          setTitulo(respostaGetItem.data.publicacao.titulo);
          setTexto(respostaGetItem.data.publicacao.texto);
          setArquivos(respostaGetItem.data.arquivos);
          setLoading(false);
        } else {
          setLoading(false);
          AddToast({texto: respostaGetItem.error, tipo: "erro"});
        }
      } catch (e) {
        setLoading(false);
        AddToast({texto: e, tipo: "erro"});
      }
    } else {
      setLoading(false);
    }
  }

  useState(() => {load()}, [publicacaoUuid]);

  if (!carregado) {
    if (location.state.propUuid !== 0 && publicacaoUuid === '') {
      setPublicacaoUuid(location.state.propUuid);
    }
    setPageInfo(
      {
        ...pageInfo,
        titulo: 'Publicações',
        icone: <FaNewspaper size={30}/>
      }
    );
    setCarregado(true);
  }

  const addArquivos = async (e) => {
    setLoading(true);
    try {
      let respostaCreateArquivo = await ArquivoApi.create(user.uuid, publicacaoUuid, e.target.files);
      if (!respostaCreateArquivo.error) {
        AddToast({texto: "Adicionado!", tipo: "sucesso"});
        load();
      }
    } catch (e) {
      setLoading(false);
      AddToast({texto: e, tipo: "erro"});
    }
  }

  const sendPublicacao = async () => {
    setLoading(true);
    if (validarCampos()) {
      try {
        let respostaCreate;
        if (!publicacaoUuid) {
          respostaCreate = await PublicacaoApi.create(
            user.uuid,
            titulo,
            texto
          );
        } else {
          respostaCreate = await PublicacaoApi.update(
            user.uuid,
            publicacaoUuid,
            titulo,
            texto
          );
        }
        if (!respostaCreate.error) {
          setPublicacaoUuid(respostaCreate.data.uuid);
          setTitulo(respostaCreate.data.titulo);
          setTexto(respostaCreate.data.texto);

          AddToast({texto: "Sucesso!", tipo: "sucesso"});
          setLoading(false);
        } else {
          AddToast({texto: respostaCreate.error, tipo: "erro"});
          setLoading(false);
        }
      } catch (err) {
        AddToast({texto: err, tipo: "erro"});
        setLoading(false);
      }
    }
    setLoading(false);
  }

  const toggleStatus = async (uuid_arquivo) => {
    setLoading(true);
    try {
      let respostaStatus = await ArquivoApi.toggleStatus(user.uuid, uuid_arquivo);
      if (!respostaStatus.error) {
        setLoading(false);
        AddToast({texto: "Sucesso!", tipo: "sucesso"});
      } else {
        setLoading(false);
        AddToast({texto: respostaStatus.error, tipo: "erro"});
      }
    } catch (e) {
      setLoading(false);
      AddToast({texto: e, tipo: "erro"});
    }
    load();
  }

  const deleteItem = async (uuid_arquivo) => {
    setLoading(true);
    try {
      let respostaDelete = await ArquivoApi.delete(user.uuid, uuid_arquivo);
      if (!respostaDelete.error) {
        setLoading(false);
        AddToast({texto: "Sucesso!", tipo: "sucesso"});
      } else {
        setLoading(false);
        AddToast({texto: respostaDelete.error, tipo: "erro"});
      }
    } catch (e) {
      setLoading(false);
      AddToast({texto: e, tipo: "erro"});
    }
    setModalDelete(false);
    load();
  }

  return (
    <div className="painel-itens">
      {publicacaoUuid ? <h2 className="titulo">Editar publicação</h2> :
        <h2 className="titulo">Adicionar uma publicação</h2>}
      <div className="form-publicacao">
        <div className="publicacao">
          <InputTextCustom
            label="Título:"
            value={titulo}
            onChange={(e) => setTitulo(e.target.value)}
            helperText={helperTitulo}
            error={errorTitulo}
          />
          <InputTextArea
            label="Descrição:"
            value={texto}
            onChange={(e) => setTexto(e.target.value)}
            error={errorTexto}
            helperText={helperTexto}
          />
          <div className="d-flex justify-end">
            <div className="btn btn-cancelar" onClick={() => navigate(-1)}>
              Cancelar
            </div>
            <div className="btn btn-enviar" onClick={sendPublicacao}>
              Cadastrar
            </div>
          </div>
        </div>

        <div className="arquivos arquivo">
          <h3 className="label">Arquivos:</h3>
          <div className="btn btn-primary" onClick={
            () => {
              if (!publicacaoUuid) {
                sendPublicacao();
                setTimeout(() => {
                  if (publicacaoUuid) {
                    inputRef.current.click();
                  }
                }, 1000);
              } else {
                inputRef.current.click();
              }
            }
          }>
            Inserir Arquivo
            <input type="file"
                   onChange={addArquivos}
                   multiple
                   accept="image/*,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                   ref={inputRef}
                   style={{display: "none"}}
            />
          </div>
          {arquivos && arquivos.map((item) => (
            <div className="arquivo-item" key={item.uuid}>
              <div className="publicacao-info">
                <span className="titulo" style={{margin: 0}} title={item.nome}>{item.nome}</span>
              </div>
              <div className="opcoes">
                <div className="switch">
                  <Switcher checked={item.status} onClick={() => toggleStatus(item.uuid)}/>
                </div>
                <a className="btn btn-cancelar" target="_blank" href={item.link} rel="noreferrer">
                  <span>Visualizar</span>
                </a>
                <div className="btn btn-primary"
                     onClick={() => {
                       setModalDelete(true);
                       setItemDelete(item.uuid);
                     }}
                >
                  <span>Excluir</span>
                </div>
              </div>
            </div>
          ))}
          {modalDelete &&
            <div className="modal-delete">
              <div className="delete-box">
                <span>Tem certeza que deseja remover o arquivo?</span>
                <div className="button" onClick={() => deleteItem(itemDelete)}>
                  Sim
                </div>
                <div className="button" onClick={() => setModalDelete(false)}>
                  Não
                </div>
              </div>

            </div>
          }
        </div>
      </div>
    </div>
  );
}